<div class="card bg-dark-lighter">
  <div class="card-body">
    <div class="mb-3">
      <div class="row">
        <div class="col-xl-4 col-lg-6 br">
          <div class="row mb-3">
            <label class="control-label col-auto">UserName:</label>
            <div class="col">
              <span>{{data?.firstName + ' ' + data?.lastName}}</span>
            </div>
          </div>
          <div class="row mb-3">
            <label class="control-label col-auto">Email:</label>
            <div class="col">
              <span>{{data?.email}}</span>
            </div>
          </div>
        </div>
        <div class="col-xl-4 col-lg-6">
          <div class="row mb-3">
            <label class="control-label col-auto">MT5 Account:</label>
            <div class="col">
              <span>{{data?.login}}</span>
            </div>
          </div>
          <div class="row mb-3">
            <label class="control-label col-auto">Total Balance:</label>
            <div class="col">
              <span>{{data?.totalBalance | DecimalPipe:fixedNumber[data?.currency] }} {{data?.currency | uppercase}}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="table-responsive">
            <table class="rox-table table-bordered">
              <thead>
                <tr>
                  <th class="text-center font-bold">Total Vol</th>
                  <th class="text-center font-bold">Total Order</th>
                  <th class="text-center font-bold">Total PnL</th>
                  <th class="text-center font-bold">Realized PnL</th>
                  <th class="text-center font-bold">Total Deposit</th>
                  <th class="text-center font-bold">Total Withdraw</th>
                  <th class="text-center font-bold">Net Asset</th>
                  <th class="text-center font-bold">Profit/Net Balance Ratio</th>
                  <th class="text-center font-bold">Bonus Detail</th>
                  <th class="text-center font-bold"> <span>Bonus Contribution
                    <i
                      tooltipPosition="top"
                      class="fa fa-info-circle fs-5"
                      pTooltip="Present the total bonus amount used in all the closed positions
                      E.x:
                        • On 01.01.2023: $50 bonus amount generated $10 realized PnL
                        • On 02.01.2023: $50 bonus amount generated $20 realized PnL
                        • On 03.01.2023: $0 bonus amount used to place order
                        -> The total bonus amount used = $100; realized PnL = $30"
                    >
                    </i>
                  </span></th>
                  <th class="text-center font-bold">Realized PnL from Bonus</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="text-center text-btc" >
                    <span>{{ data?.totalVolume | DecimalPipe:fixedNumber['usd']}}</span>
                  </td>
                  <td class="text-center">
                    {{ data?.totalOrder }}
                  </td>
                  <td class="text-center text-btc" title="{{ data?.totalPNL }}">
                    {{data?.totalPNL | DecimalPipe:fixedNumber[data?.currency] }}
                  </td>
                  <td class="text-center text-btc" title="{{ data?.realizedPnl }}">
                    {{data?.realizedPnl | DecimalPipe:fixedNumber[data?.currency] }}
                  </td>
                  <td class="text-center text-btc" title="{{ data?.deposit }}">
                    {{data?.deposit | DecimalPipe:fixedNumber[data?.currency]}}
                  </td>
                  <td class="text-center text-btc" title="{{ data?.withdraw }}">
                    {{data?.withdraw | DecimalPipe:fixedNumber[data?.currency] }}
                  </td>
                  <td class="text-center text-btc" title="{{ data?.netAsset }}">
                    {{data?.netAsset | DecimalPipe:fixedNumber[data?.currency] }}
                  </td>
                  <td class="text-center text-btc">
                    <span>{{ getPercentBalanceRatio() }}</span>
                  </td>
                  <td class="text-center text-btc">
                    <a
                      href="javascript:void(0)"
                      class="text-blue-lighter"
                      (click)="getBonusDetail()"
                      data-bs-toggle="modal"
                      data-bs-target="#modalBonusDetail"
                      ><i class="fa fa-eye"></i>
                    </a>
                  </td>
                  <!-- <td class="text-end">{{ data?.bonusContribution | DecimalPipe : fixedNumber[data?.currency]  }}</td> -->
                  <td class="text-end">
                    <a *ngIf="data?.bonusContribution; else notAllowViewBonusContribution" class="text-blue-lighter view" style="cursor: pointer;" (click)="viewTrainingHistory(data)">
                      {{ data?.bonusContribution | DecimalPipe:fixedNumber[data?.currency]  }}
                    </a>
                    <ng-template #notAllowViewBonusContribution>
                      {{ data?.bonusContribution | DecimalPipe:fixedNumber[data?.currency] }}
                    </ng-template>
                  </td>
                  <td class="text-center text-btc">
                    <span>{{ data?.totalPBB  | number:"1.2-2"  }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade fx-modal" id="modalBonusDetail">
    <div class="modal-dialog modal-xl modal-dialog-centered">
      <div class="modal-content">
        <!-- Modal body -->
        <div class="modal-body mb-3">
          <div class="row">
            <div class="row mb-3">
              <label class="control-label col-auto">Current Bonus:</label>
              <div class="col">
                <span>{{data?.bonus | DecimalPipe:fixedNumber[data?.currency]}}</span>
              </div>
            </div>
            <div class="row mb-3">
              <label class="control-label col-auto">Current Applied Bonus:</label>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 col-xs-12">
              <div class="table-responsive">
                <table class="rox-table table-bordered">
                  <thead>
                  <tr>
                    <th class="text-center">Promotion Code</th>
                    <th class="text-center">Status</th>
                    <th class="text-center">Promotion Type</th>
                    <th class="text-center">Bonus Content</th>
                    <th class="text-center">Expiration Date</th>
                  </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="
                    let item of bonusInfo
                      | paginate
                        : {
                            id: 'bonus_info',
                            itemsPerPage: pageInfo.pageSize,
                            currentPage: pageInfo.pageIndex,
                            totalItems: pageInfo.totalRecord
                          };
                    let i = index
                  ">
                  <td class="text-center">
                    {{item.code}}
                  </td>
                  <td class="text-center mw-150">{{item.status}}</td>
                  <td class="text-center">
                    <span *ngIf="item.is_enable_account">Open Account</span>
                    <span *ngIf="item.is_enable_account && item.is_enable_deposit"> / </span>
                    <span *ngIf="item.is_enable_deposit">Deposit</span>
                  </td>
                  <td class="text-start mw-150">
                    <ng-container *ngIf="item.is_enable_deposit">
                      <div class="fs-13 text-yellow"
                           *ngFor="let condition of item.data?.deposit.conditions" style="white-space: nowrap">
                        <ng-container *ngIf = condition.rate || condition.threshold>
                          <span> ~ </span>
                          <span labelNumber="{{condition.threshold}}" [currency]="'jpy'"></span>
                          <span> | Bonus: </span>
                          <span labelNumber="{{(condition.rate * 100)}}" [currency]="'per'"></span>
                          %
                        </ng-container>
                      </div>
                    </ng-container>
                  </td>
                  <td class="text-center">
                    <span>{{item.start_time | date: 'yyyy/MM/dd HH:mm'}}</span>
                    <span> - </span>
                    <span>{{item.end_time | date: 'yyyy/MM/dd HH:mm'}}</span>
                  </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-15">
          <div class="col">
            <div class="pagination-wrapper">
              <pagination-controls
                id="bonus_info"
                (pageChange)="pageChanged($event)"
                autoHide="true"
                responsive="true"
                previousLabel="Prev"
                nextLabel="Next"
              >
              </pagination-controls>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <div class="d-flex justify-content-center mt-3">
            <button data-bs-dismiss="modal"  class="btn-outline-cancel ms-2" mat-button >Cancel</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

